import { quizStore } from '@/stores/quiz/quiz'

export default {
    // common
    setLoading(isLoading) {
        this.commitMutation('setLoading', isLoading);
    },


    changeToPrevScreen() {
        this.commitMutation('changeToPrevScreen');
    },

    changeToScreen(screenNo) {
        this.commitMutation('changeToScreen', screenNo);
    },

    setQuizModalMeta(quizModalType, quizModalSubType) {
        this.commitMutation('setQuizModalMeta', { quizModalType, quizModalSubType });
    },

    async getDataFromApi(url) {

        try {
            const response = await $fetch(useCountryPath(url));
            if (response?.success) {
                return response?.data
            }

        } catch (error) {
            console.log(error, 'error')
        }
    },

    async getDiamondMinPrice() {
        try {
            const response = await $fetch(useCountryPath('/diamond/filter/loose'), {
                method: 'GET',
                query: {
                    'Clarity': 'SI1,VS2,VS1,VVS2,VVS1,IF,FL',
                    'Cut': 'EX,ID',
                    'Color': 'H,G,F,E,D',
                    'CaratFrom': 1,
                    'CaratTo': 29.18,
                    'Sort': 'PriceLow',
                    'page': 1
                }
            });
            if (response?.success) {
                return response?.data
            }

        } catch (error) {
            console.log(error, 'error')
        }
    },

    setSelectedQuizTypes(type, subtype) {
        this.commitMutation('setSelectedQuizTypes', { type, subtype })
    },

    async setScreensDataFromApi() {
        let response = null
        const store = quizStore()

        const type = store.getActiveQuizModalType()
        const subtype = store.getActiveQuizModalSubType()
        this.setLoading(true)
        switch (type) {
            case 'cyo': {
                if (subtype === 'ring') {
                    response = await this.getDataFromApi('/config/setting/filters/min-max?Category=ring&pageSlug=all'); //merchant rings
                } else if (subtype === 'diamond') {

                    const [minmax, listData] = await Promise.all([
                        this.getDataFromApi('/diamond/filter/min-max'),
                        this.getDiamondMinPrice()
                    ])

                    if (minmax) {
                        response = minmax

                        const item = listData?.data[0]
                       
                        if (response?.price && item?.price) {
                            response.price.min = item?.price
                            response.price.from = item?.price
                        }
                    }
                }

                break
            }
            case 'shop': {
                response = await this.getDataFromApi(`/config/shop/filters/min-max?sub_type=`);
                break
            }
        }
        if (response) {
            this.commitMutation('setScreensDataFromApi', response);
        }


        this.setLoading(false)
    },



    setActiveSelectType(screenName, value) {
        this.commitMutation('setActiveSelectType', { screenName, value });
    },

    setActiveMultiSelectType(screenName, value) {
        this.commitMutation('setActiveMultiSelectType', { screenName, value });
    },

    setUserEmail(value) {
        this.commitMutation('setUserEmail', value);
    },

    resetQuiz() {
        this.commitMutation('resetQuiz')
    }

}


